import React from 'react';

import MobileTable from './MobileTable';
import QuantityPicker from '../../../common/QuantityPicker';

const MobileComponent = (props) => {
  const {
    Wrapper,
    data,
    loading,
    handleNewItem,
    handleRemoveItem,
    currentVariant,
    currentQuantityInput,
    currentQuantityInputValue,
    handleToggleQuantityInput,
    handleUpdateQuantity,
    setCurrentQuantityInputValue,
    setCurrentQuantityInput,
    TableWrap,
    allowVariativeBundles,
    isNew,
    handleUpdateOptional,
    handleUpdateBundleOptionalCount,
    requiredQuantity,
  } = props;
  return (
    <Wrapper className="card-box">
      <div className="row">
        <div className="col-12">
          <h4 className="header-title" style={{ marginBottom: '10px' }}>
            Состав виртуального набора
          </h4>
        </div>
      </div>
      <div className="row mb-2">
        {data && allowVariativeBundles && !isNew && (
          <div className="col-10">
            <div>
              <div className="font-14">
                Необходимое количество товаров для добавления набора в заказ
              </div>
              <div className="red">Не зависит от количества самого товара в наборе</div>
            </div>
            <div className="row mt-1">
              <div className="col-6">
                <QuantityPicker
                  value={data?.bundleOptionalCount + requiredQuantity}
                  reverse
                  min={requiredQuantity}
                  max={data?.length}
                  onChange={(value) => handleUpdateBundleOptionalCount(value)}
                />
              </div>
            </div>
          </div>
        )}
      </div>
      <div className="row">
        <div className="col-12">
          <MobileTable
            data={data}
            creatable
            bottomCreateButton
            removable
            createLabel="+ Добавить товар в набор"
            loading={loading}
            handleNewItem={handleNewItem}
            handleRemoveItem={handleRemoveItem}
            currentQuantityInput={currentQuantityInput}
            currentQuantityInputValue={currentQuantityInputValue}
            handleToggleQuantityInput={handleToggleQuantityInput}
            handleUpdateQuantity={handleUpdateQuantity}
            setCurrentQuantityInputValue={setCurrentQuantityInputValue}
            setCurrentQuantityInput={setCurrentQuantityInput}
            TableWrap={TableWrap}
            allowVariativeBundles={allowVariativeBundles}
            isNew={isNew}
            handleUpdateOptional={handleUpdateOptional}
          />
        </div>
      </div>
    </Wrapper>
  );
};

export default MobileComponent;
